export default __webpack_public_path__ + "static/media/logo-md-1920w.bc0dd287.avif";